import { WEB_SERVICES } from "../../../../bitSagas/webServices";
import { USER_TYPE } from '../../../../bitConstants/constants';
import { WEBSERVICE_ERRORS } from '../../../errorCatalog';

export const getHandledErrors = (errorToPrint) => {
  const handledErrors = {
    common: {
      BUSINESS_ERRORS: {
        INCOMPATIBLE_PRODUCT_BY_ZONE: errorToPrint.INCOMPATIBLE_PRODUCT_BY_ZONE,
      },
      WEB_SERVICES_RULES: {
        [WEB_SERVICES.INIT_CQ]: {
          [WEBSERVICE_ERRORS.WITHOUT_DEPENDENT_OFFER]: errorToPrint.INCOMPATIBLE_PRODUCT,
          [WEBSERVICE_ERRORS.MAX_CARDINALITY_REACHED]: errorToPrint.MAX_CARDINALITY_REACHED,
          [WEBSERVICE_ERRORS.OFFER_WITH_SOME_DEPENDENCIES]: errorToPrint.OFFER_WITH_SOME_DEPENDENCIES,
        },
      },
    },
    [`user_${USER_TYPE.TELCO}`]: {
      WEB_SERVICES_RULES: {
        [WEB_SERVICES.INIT_CQ]: {
        },
      },
    },
    [`user_${USER_TYPE.OPEN}`]: {

    },
  }

  return handledErrors;
}
